/*
 * Menu state
 *
 * Shows the menu
 */

import Logo from '../objects/Logo';

export default class Menu extends Phaser.State {

    create() {

        this.game.stage.backgroundColor = '#e5ba69';

        const {centerX: x, centerY: y} = this.world;


        // TEXT
        var style_press = { font: "italic 19px Arial", fill: "#000000", align: "center" };

        // LOGO
        this.add.sprite(0,0, 'titlescreen');

        this.info = this.add.text(150, 210,
            'A simple "Tanks" clone (not enough\r'
            +'time to make a "Worms" clone of it ;) )\r'
            +'\r'
            +'"The ONAGER was a Roman siege engine that is a type\r'
            +'of catapult that uses a torsional force,... (wikipedia)\r'
            +'Use your LEFT and RIGHT cursor to move the "stopper"\r'
            +'which will determine the angle at which the stone\r'
            +'leaves the "arm" of the onager.\r'
            +'Press SPACE and hold to build up power, release SPACE\r'
            +'to shoot the stone.\r'
            +'No time for sound + better gfx + more gameplay, have fun :)\r'
            +'Made by Larzan the unmotivated for LD#36, the lost one.',
            style_press);
        this.text = this.add.text(x + 150, y + 250, 'Click to Start', style_press);
        // this.menu_logo = new LogoAnimated(this.game, x, y-120);
        // this.add.existing(this.menu_logo);
        //
        // this.menu_logo.tween_rotate();



        this.input.onDown.add(this._onDown, this);


        // init keycapture
        // --------------------------
        this._initKeyCapture();
        // --------------------------


    }

    //  TOOL FUNCTION
    // ==============================================


    _initKeyCapture() {
        var that = this;
        window.onkeydown = function(event) {
            var thet = that;
            if (typeof thet.game.state.getCurrentState()._onKey !== 'undefined') {
                thet.game.state.getCurrentState()._onKey();
            }
        };
    }

    _onDown() {
        this.state.start('Game');
    }

}
